import { PassageTaskCreateDto, type PassageTaskCreateInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task/passage-task-create.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

/** Passage task create API request body for personal account mode - DTO signature */
export type PassageTaskLkCreateInterface = Omit<PassageTaskCreateInterface, 'client'>;

/** Passage task create API request body for personal account mode - DTO schema */
export const PassageTaskLkCreateDto = SerdeDtoClass.omit(PacsDtoKeysEnum.PASSAGE_TASK_LK_CREATE_DTO, PassageTaskCreateDto, ['client']);
